import { XApiEventsModuleServerFactory, XApiEventsModuleClientFactory } from '../types';

export const serverFactory: XApiEventsModuleServerFactory = eventsModule => eventsModule;
export const clientFactory: XApiEventsModuleClientFactory = eventsModule => eventsModule;
